
import { _getStartEndColumns } from './_getStartEndColumns';

export const _getItemsBeforeThisWidgetInThisRow = ({
  widgetIndex: _widgetIndex,
  config,
  startCol: _startCol,
  TOTAL_COLUMNS,
}) => {
  let startCol = _startCol;
  let widgetIndex = _widgetIndex;
  const itemIndexes = [];
  if (startCol !== 1) {
    while (startCol > 1) {
      const prevItem = config[widgetIndex - 1];
      const [sC, eC] = _getStartEndColumns(prevItem.gridColumn);

      itemIndexes.unshift(widgetIndex - 1);
      startCol = sC;
      widgetIndex--;
    }
  }
  return itemIndexes;
};